import {
  cannedWorkPackageQuery,
  useArchiveCannedWorkPackageMutation,
} from "@common/api/quoting/canned"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/templates/quotes_/$packageId/overview/archive",
)({
  component: ArchiveTemplateQuote,
})

function ArchiveTemplateQuote(): React.ReactElement {
  const { packageId } = Route.useParams()
  const { data: item } = useSuspenseQuery(
    cannedWorkPackageQuery({ package_id: packageId }),
  )
  const mutation = useArchiveCannedWorkPackageMutation()
  const navigate = useNavigate()
  const showToast = useCustomToast()

  return (
    <ConfirmDialog
      title={`Archive ${item.name}?`}
      description="New quotes can't start from it. Its template tasks stay as they are. You can restore it later."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={mutation.isPending}
      onConfirm={() =>
        mutation.mutate(
          { package_id: packageId },
          {
            onSuccess: () => {
              showToast("Archived", `${item.name} archived.`, "success")
              void navigate({ to: "/templates/quotes" })
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
      onCancel={() =>
        navigate({
          to: "/templates/quotes/$packageId/overview",
          params: { packageId },
        })
      }
    />
  )
}
